var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-skeleton-wrapper',[_c('b-row',_vm._l((_vm.counts),function(count){return _c('b-col',{key:count,staticClass:"mb-1",attrs:{"md":"4"}},[_c('b-skeleton',{staticClass:"mx-auto",attrs:{"type":"avatar","size":"96px"}}),_c('b-skeleton',{attrs:{"type":"Image","height":_vm.boxHeight}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }